import { ThemeBus } from "./events-bus.js";
import { EVENTS } from "./event-constants.js";

/**
 * Related Products Component
 * Lazy loads product recommendations when section enters viewport
 * Dispatches gridUpdated event to initialize lazy loading and other components
 */
class RelatedProducts {
  constructor() {
    this.section = document.querySelector('.product-recommendations');
    
    if (!this.section) {
      return;
    }

    if (!this.section.dataset.url) {
      return;
    }

    this.init();
  }

  init() {
    const observer = new IntersectionObserver(
      (entries, obs) => this.handleIntersection(entries, obs),
      { rootMargin: '0px 0px 200px 0px' }
    );

    observer.observe(this.section);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) {
      return;
    }

    observer.unobserve(this.section);
    this.loadRecommendations();
  }

  async loadRecommendations() {
    const url = this.section.dataset.url;

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.section.innerHTML = recommendations.innerHTML;
        
        // Dispatch gridUpdated event to trigger lazy loading (centralized in lazy-image.js)
        ThemeBus.dispatchEvent(new Event(EVENTS.gridUpdated));
        requestAnimationFrame(() => {
          if (typeof window.initSliderBlocks === "function") {
            window.initSliderBlocks();
          }
        });
      }
    } catch (error) {
      // Silent fail
    }
  }
}

export async function initRelatedProducts() {
  new RelatedProducts();
}

// Auto-initialize when module loads
initRelatedProducts();